export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="font-heading text-lg font-bold text-background-50 mb-4">网红爆料</h3>
            <p className="text-sm text-secondary-400 leading-relaxed">
              追踪网红爆料事件最新瓜、大事件与热门争议话题，每日深扒网红内幕爆料大瓜，汇总吃瓜热点，最新网红爆料合集一网打尽。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#ranking" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer">热度榜单</a></li>
              <li><a href="#carousel" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer">焦点专题</a></li>
              <li><a href="#cards" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer">爆料精选</a></li>
              <li><a href="#updates" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer">最新动态</a></li>
              <li><a href="#faq" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer">常见问答</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">热门话题</h4>
            <ul className="space-y-2">
              <li><a href="#topics" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer">网红争议</a></li>
              <li><a href="#topics" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer">直播翻车</a></li>
              <li><a href="#topics" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer">内幕爆料</a></li>
              <li><a href="#topics" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer">吃瓜热点</a></li>
              <li><a href="#topics" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer">大瓜汇总</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">合作伙伴</h4>
            <p className="text-sm text-secondary-500">敬请期待</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-secondary-500">
            &copy; {new Date().getFullYear()} 网红爆料 — 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer">联系我们</a>
            <a href="#faq" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer">常见问答</a>
            <a href="#hero" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer">返回顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}